"use client";

import { ReactNode } from "react";
import Markdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkBreaks from "remark-breaks";
import remarkGfm from "remark-gfm";

import type { ClassAttributes, HTMLAttributes } from "react";
import type { ExtraProps } from "react-markdown";

type Props = {
  children: ReactNode;
};

const H2 = ({
  node,
  children,
}: ClassAttributes<HTMLHeadingElement> &
  HTMLAttributes<HTMLHeadingElement> &
  ExtraProps) => {
  const title =
    node && Boolean(node?.children[0]) && "value" in node.children[0]
      ? node.children[0].value
      : "";
  return (
    <h2>
      <a id={title} href={`#${title}`}>
        {children}
      </a>
    </h2>
  );
};

export const Marked = ({ children }: Props) => {
  if (children === undefined || children === null) return <>a</>;
  return (
    <div className="text-base">
      <Markdown
        className="markdown"
        remarkPlugins={[remarkGfm, remarkBreaks]}
        rehypePlugins={[rehypeRaw]}
        components={{
          h2: H2,
        }}
      >
        {children.toString()}
      </Markdown>
    </div>
  );
};
